import { render } from "./ModalItemCategory.vue?vue&type=template&id=e348e9c8"
import script from "./ModalItemCategory.vue?vue&type=script&lang=js"
export * from "./ModalItemCategory.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__